import React, { useCallback, useEffect, useRef, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button, Image, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { useLocation, useNavigate } from 'react-router-dom';
import CompanyBlock from '../components/CompanyBlock';
import FacilityBlock from '../components/FacilityBlock';
import { useApi } from '../api/contexts/ApiContext';
import { OpportunityApi } from '../api/modules/OpportunityApi';
import { Company, Facility } from '../types/type';

interface apiGateStructure {
    apiGate: string,
    query?: {},
}

interface DataStructure {
    company_count?: number;
    facility_count?: number;
    company?: Company[];
    facility?: Facility[];
}

const SearchResult: React.FC = () => {
    const { getModule } = useApi();
    const navigate = useNavigate();
    const { userInfo } = useSelector((state: RootState) => state.auth);
    const { vendorInfo } = useSelector((state: RootState) => state.vendor);
    const [userId, setUserId] = useState('');
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    // const { keyword, category, search } = location.state || {};
    const keyword = queryParams.get('keyword') || '';
    const category = queryParams.get('category') || '';
    const searchStr: any = queryParams.get('search') || '';;
    const urlQueryMode = queryParams.get('mode') == 'facility' ? 'facility' : 'company';
    // クエリパラメータのsearchはJSONをオブジェクトに変換して使う
    let search: any = {};
    try {
        if (searchStr) {
            search = JSON.parse(decodeURIComponent(searchStr));
        }
    } catch (e) {
        console.warn("Invalid search param", e);
    }

    const initialPage = parseInt(queryParams.get('page') || '1', 10);
    const [page, setPage] = useState(initialPage);
    const [mode, setMode] = useState(urlQueryMode);
    // const [isEmptySearch, setIsEmptySearch] = useState(false);
    const [data, setData] = useState<DataStructure>({});
    const [apiGate, setApiGate] = useState<apiGateStructure>({ apiGate: '' });
    const [loading, setLoading] = useState(false);
    const PER_PAGE = 9;
    const fromRecordNum = (PER_PAGE * page) - PER_PAGE;
    // const [keyword, setKeyword] = useState(queryParams.get('keyword') || '');
    // const [category, setCategory] = useState(queryParams.get('category') || '');
    // const [search, setSearch] = useState<any>({});

    const handleSearch = useCallback(async () => {
        let empty = !Boolean(keyword || category || searchStr);
        // if (Boolean(keyword || category || search)) {
        //     setIsEmptySearch(false);
        // } else {
        //     setIsEmptySearch(true);
        // }

        if (category) {
            if (category === "recent") {
                setApiGate({ apiGate: 'getRecentlyViewed', query: undefined });
            } else if (category === "new") {
                setApiGate({ apiGate: 'getNewOpportunities', query: undefined })
            } else if (category === "recommended") {
                if (vendorInfo?.preference) {
                    const preference: any = vendorInfo?.preference;
                    let q: any = {};

                    if (preference['preference-load'] && preference['preference-load'].length > 0) {
                        q.load = preference['preference-load'];
                    }
                    if (preference['preference-load_custom_from'] && preference['preference-load_custom_from'].length > 0) {
                        q.load_custom_from = preference['preference-load_custom_from'];
                    }
                    if (preference['preference-load_custom_to'] && preference['preference-load_custom_to'].length > 0) {
                        q.load_custom_to = preference['preference-load_custom_to'];
                    }
                    if (preference['preference-contract_usage'] && preference['preference-contract_usage'].length > 0) {
                        q.contract_usage = preference['preference-contract_usage'];
                    }
                    if (preference['preference-contract_usage_from'] && preference['preference-contract_usage_from'].length > 0) {
                        q.contract_usage_from = preference['preference-contract_usage_from'];
                    }
                    if (preference['preference-contract_usage_to'] && preference['preference-contract_usage_to'].length > 0) {
                        q.contract_usage_to = preference['preference-contract_usage_to'];
                    }
                    if (preference['preference-usage'] && preference['preference-usage'].length > 0) {
                        q.usage = preference['preference-usage'];
                    }
                    if (preference['preference-usage_custom_from'] && preference['preference-usage_custom_from'].length > 0) {
                        q.usage_custom_from = preference['preference-usage_custom_from'];
                    }
                    if (preference['preference-usage_custom_to'] && preference['preference-usage_custom_to'].length > 0) {
                        q.usage_custom_to = preference['preference-usage_custom_to'];
                    }
                    if (preference['preference-industry'] && preference['preference-industry'].length > 0) {
                        q.industry = preference['preference-industry'];
                    }
                    if (preference['preference-area'] && preference['preference-area'].length > 0) {
                        q.area = preference['preference-area'];
                    }
                    if (q.length > 0) {
                        setApiGate({ apiGate: 'getOpportunitiesBySearchConditions', query: q });
                        // setIsEmptySearch(false);
                        empty = false;
                    }
                }
            } else if (category === "ending") {
                setApiGate({ apiGate: 'getOpportunitiesEndingSoon', query: undefined })
            } else if (category === "closed") {
                setApiGate({ apiGate: 'getOpportunitiesClosed', query: undefined })
            } else if (category === "favorite") {
                setApiGate({ apiGate: 'getOpportunitiesFavorite', query: undefined })
            }
        } else if (keyword) {
            let q: any = {};
            q.keyword = keyword;
            setApiGate({ apiGate: 'getOpportunitiesBySearchConditions', query: q });
        } else {
            let q: any = {};
            if (search?.contract_categories && search.contract_categories.length > 0) {
                q.contract_categories = search.contract_categories;
            }
            if (search?.load && search.load.length > 0) {
                q.load = search.load;
            }
            if (search?.load_custom_from && search.load_custom_from !== "") {
                q.load_custom_from = search.load_custom_from;
            }
            if (search?.load_custom_to && search.load_custom_to !== "") {
                q.load_custom_to = search.load_custom_to;
            }
            if (search?.contract_usage && search.contract_usage.length > 0) {
                q.contract_usage = search.contract_usage;
            }
            if (search?.contract_usage_from && search.contract_usage_from !== "") {
                q.contract_usage_from = search.contract_usage_from;
            }
            if (search?.contract_usage_to && search.contract_usage_to !== "") {
                q.contract_usage_to = search.contract_usage_to;
            }
            if (search?.usage && search.usage.length > 0) {
                q.usage = search.usage;
            }
            if (search?.usage_custom_from && search.usage_custom_from !== "") {
                q.usage_custom_from = search.usage_custom_from;
            }
            if (search?.usage_custom_to && search.usage_custom_to !== "") {
                q.usage_custom_to = search.usage_custom_to;
            }
            if (search?.industry && search.industry.length > 0) {
                q.industry = search.industry;
            }
            if (search?.area && search.area.length > 0) {
                q.area = search.area;
            }

            if (Object.keys(q).length > 0) {
                setApiGate({ apiGate: 'getOpportunitiesBySearchConditions', query: q });
                // setIsEmptySearch(false);
                empty = false;

            }
        }

        if (empty) {
            setApiGate({ apiGate: 'getOpportunities', query: undefined });
        }
    }, [keyword, category, searchStr, vendorInfo]);

    useEffect(() => {
        const setOpportunities = async () => {
            setLoading(true);
            try {
                if (apiGate.apiGate) {
                    const opportunityApi = await getModule('OpportunityApi');
                    const url = apiGate.apiGate as keyof ReturnType<typeof OpportunityApi>;

                    const response = await opportunityApi[url]({
                        mode: mode,
                        user_id: userInfo?.id,
                        vendor_id: vendorInfo?.vendor_id,
                        conditions: apiGate.query === undefined ? {} : apiGate.query,
                        limit: PER_PAGE,
                        offset: fromRecordNum,
                    });

                    const res: any = await response.data;
                    setData(res);
                }

            } catch (e) {
                console.log(e);
            } finally {
                setLoading(false);
            }
        }
        setOpportunities();
    }, [apiGate, getModule, mode, userInfo?.id, PER_PAGE, fromRecordNum, page]);

    const handlePageChange = (newPage: number) => {
        // navigatePage(mode, newPage);

        setPage(newPage);
        // navigate(`/search_result?mode=${mode}&page=${newPage}`);
    };

    const handleModeChange = (mode: string) => {
        if (mode == 'facility') {
            setMode('facility');
        } else {
            setMode('company');
        }

        // navigatePage(mode, 1);
        // let url = `/search_result?mode=${mode}&page=1`;
        setPage(1);

        // if (keyword && keyword !== 'undefined') {
        //     url += `&keyword=${keyword}`;
        // }

        // if (category && category !== 'undefined') {
        //     url += `&category=${category}`;
        // }

        // if (search && search !== 'undefined') {
        //     url += `&search=${search}`;
        // }

        // navigate(url, {
        //     state: {
        //         keyword: keyword,
        //         category: category,
        //         search: search,
        //     }
        // });

    }
    useEffect(() => {
        navigatePage();

    }, [page, mode]);

    useEffect(() => {
        setMode(urlQueryMode);
    }, [location.search])

    useEffect(() => {
        handleSearch();
    }, [handleSearch]);


    const navigatePage = () => {
        const params = new URLSearchParams();
        if (keyword) params.set("keyword", keyword);
        if (category) params.set("category", category);
        if (searchStr) params.set("search", JSON.stringify(searchStr));
        params.set("page", String(page));
        params.set("mode", mode);
        navigate(`/search_result?${params.toString()}`);
    };


    const unit = mode === "facility" ? "施設" : "社";
    const total = mode === "facility" ? (data.facility_count ? data.facility_count : 0) :
        (data.company_count ? data.company_count : 0);
    const totalPages = Math.ceil(total / PER_PAGE);

    return (
        <>
            {/* <Header mode="company" vendor={{ companyName: vendorInfo?.companyName, lastName: userInfo?.lastName, firstName: userInfo?.firstName }} /> */}
            <section className="section-table-theme user-management">
                <div className="container">
                    <div className="row mx-0 text-center mb-lg-5 mb-4">
                        <div className="col-lg-6 px-0">
                            <a onClick={() => handleModeChange("company")}>
                                <Button variant='light' size='lg' className={`btn-theme-custom-lg btn-outline-primary rounded-0 w-100 mb-3
                            ${mode === "company" ? "active" : ""}`}>
                                    <Image className="img img-fluid mr-2" src="assets/images/other/icon-building-crossways.svg" />
                                    企業別の情報を表示する
                                </Button>
                            </a>
                        </div>
                        <div className="col-lg-6 px-0">
                            <a onClick={() => handleModeChange("facility")}>
                                <Button variant='light' size='lg' className={`btn-theme-custom-lg btn-outline-success rounded-0 w-100 mb-3
                            ${mode === "facility" ? "active" : ""}`}>
                                    <Image className="img img-fluid mr-2" src="assets/images/other/icon-building-level.svg" />施設別の情報を表示する
                                </Button>
                            </a>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-sm-12 text-center">
                            {total === 0 && !loading && (
                                <p className="text-sm fw-300">対象案件はございません</p>
                            )}
                        </div>
                        <div className="col-sm-6 my-auto">
                            <span className="text-sm fw-300">対象案件数：</span>
                            {mode === "facility" ? (
                                <>
                                    <span className="text-digit text-red-theme text-xl">{data.facility_count ?? 0}</span>
                                    <span className="text-xs">件</span>
                                </>
                            ) : (
                                <>
                                    <span className="text-digit text-red-theme text-xl">{data.company_count ?? 0}</span>
                                    <span className="text-xs">件</span>
                                </>
                            )}
                        </div>
                    </div>

                    <div className="">
                        {loading ? (
                            <div className="text-center">
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </Spinner>
                            </div>
                        ) : (
                            <div className="row">
                                {mode === "company" ? (
                                    <>
                                        {data.company && data.company.map((company, index) => (
                                            <div className="col-lg-4 mb-3" key={index}>
                                                <CompanyBlock company={company} />
                                            </div>
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        {data.facility && data.facility.map((facility, index) => (
                                            <div className="col-lg-4 mb-3" key={index}>
                                                <FacilityBlock facility={facility} />
                                            </div>
                                        ))}
                                    </>
                                )}
                            </div>
                        )}

                        <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-center">
                                {page > 1 && (
                                    <li className={`page-item ${page === 1 ? 'd-none disabled' : ''}`}>
                                        <a className="page-link" href="#" onClick={() => handlePageChange(page - 1)}>＜ 前へ</a>
                                    </li>
                                )}
                                {[...Array(totalPages)].map((_, i) => (
                                    <li className={`page-item`} key={i}>
                                        <a className={`page-link  ${page === i + 1 ? 'active' : ''}`} href="#" onClick={() => handlePageChange(i + 1)}>{i + 1}</a>
                                    </li>
                                ))}
                                {page < totalPages && (
                                    <li className={`page-item ${page === totalPages ? 'd-none disabled' : ''}`}>
                                        <a className="page-link" href="#" onClick={() => handlePageChange(page + 1)}>次へ ＞</a>
                                    </li>
                                )}
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default SearchResult;